import React from 'react';
import { aptUIActions } from 'features/appointment/services/reducers';
import appointmentSelectors from 'features/appointment/services/selectors';
import { verifyPinCode } from 'widgets/RequestAdminLocalPW/Callback';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import icLock from './ic_lock.svg';
import icUnlock from './ic_unlock.svg';
import shopSelectors from 'services/shop/selectors';
import PermissionManager from 'widgets/PermissionVerify';

const EnableDrag = () => {
  const dispatch = useAppDispatch();
  const enableDrag = appointmentSelectors.enableDrag();
  const allSetting = shopSelectors.data.allSetting();
  const onToggle = async () => {
    const nextValue = !enableDrag;
    if (nextValue) {
      const result = await PermissionManager.verify(PermissionManager.PERMISSIONS.APPOINTMENT_DRAG);
      if (result !== null) {
        if (!result || result?.skip) return dispatch(aptUIActions.setEnableDrag(nextValue));
        if (!result.verifyData) return;
        dispatch(aptUIActions.setEnableDrag(nextValue));
      } else {
        verifyPinCode(() => {
          dispatch(aptUIActions.setEnableDrag(nextValue));
        }, true);
      }
      return;
    }
    dispatch(aptUIActions.setEnableDrag(false));
  };
  if (!allSetting?.lockDragSchedule) return null;
  return (
    <Container onClick={onToggle}>
      <img src={enableDrag ? icUnlock : icLock} alt='ic-lock' />
    </Container>
  );
};

export default EnableDrag;

const Container = styled.button`
  cursor: pointer;
`;
